<template>
    <div>
        <x-table-server ref="refStoreTableServer"
                        :title="title"
                        :resource="resource"
                        :show-filter="true"
                        :show-button-new="true"
                        @click-create="clickCreate()">
            <template v-slot:table-rows="props">
                <tr v-for="row in props.records">
                    <td v-for="col in props.columns" :class="col.class_col_body" :key="col['name']">
                        <template v-if="col['name'] === 'number'">
                            <span class="font-weight-bold">{{ row.number }}</span>
                            <span v-if="row.note_number"><br/>{{ row.note_number }}</span>
                            <span v-if="row.affected_number"><br/>{{ row.affected_number }}</span>
                        </template>
                        <template v-else-if="col['name'] === 'supplier_number'">
                            <span class="font-weight-bold">{{ row.supplier_name }}</span>
                            <span v-if="row.supplier_number"><br/>{{ row.supplier_number }}</span>
                        </template>
                        <template v-else-if="col['name'] === 'state_type_payment'">
                            <button type="button"
                                :class="row.state_type_payment_description == 'Pagado' ? 'btn waves-effect waves-light btn-xs m-1__2   btn-success': 'btn waves-effect waves-light btn-xs m-1__2 btn-warning'">
                                {{ row.state_type_payment_description }}
                            </button>
                        </template>
                        <template v-else-if="col['name'] === 'products'">
                            <button
                                type="button"
                                style="min-width: 41px"
                                class="btn waves-effect waves-light btn-xs btn-info m-1__2"
                                @click.prevent="clickShowItems(row.id)"><i class="fa fa-list"></i>
                            </button>
                        </template>
                        <template v-else-if="col['name'] === 'state_type_id'">
                            <span>{{ row.state_type_description }}</span>
                        </template>
                        <template v-else-if="col['name'] === 'actions'">
                            <template v-if="permissions.edit_purchase && row.state_type_id!='11'">
                                <a :href="`/${resource}/edit/${row.id}`"
                                   type="button"
                                   class="btn waves-effect waves-light btn-xs btn-info"
                                   v-if="row.btn_edit">Editar</a>
                            </template>
                            <template v-if="permissions.annular_purchase && row.state_type_id!='11'">
                                <button type="button"
                                        class="btn waves-effect waves-light btn-xs btn-danger"
                                        @click.prevent="clickAnulate(row.id)"
                                        v-if="row.btn_voided">Anular
                                </button>
                            </template>
                            <template v-if="permissions.delete_purchase && row.state_type_id==='11'">
                                <button type="button"
                                        class="btn waves-effect waves-light btn-xs btn-danger"
                                        @click.prevent="clickDelete(row.id)"
                                        v-if="row.btn_delete">Eliminar
                                </button>
                            </template>
                            <button type="button"
                                    class="btn waves-effect waves-light btn-xs btn-primary"
                                    @click.prevent="clickOptions(row.id)"> <i class="fa fa-print"></i> Imprimir
                            </button>
                            <template v-if="row.state_type_id != '11' ">
                                <button
                                    type="button"
                                    :disabled="disableGuideBtn"
                                    class="btn waves-effect waves-light btn-xs btn-warning"
                                    @click.prevent="clickGuide(row.id)"
                                    v-if="row.btn_dispatch">Guía
                                </button>
                                <a :href="`/${resource}/note/form/${row.id}`"
                                   type="button"
                                   class="btn waves-effect waves-light btn-xs btn-info"
                                   v-if="row.btn_note">Nota</a>
                                <button
                                    type="button"
                                    style="min-width: 41px"
                                    class="btn waves-effect waves-light btn-xs btn-info"
                                    @click.prevent="clickPurchasePayment(row.id)"
                                    v-if="row.view_payments">Pagos</button>
                            </template>
                        </template>
                        <template v-else>
                            {{ row[col['name']] }}
                        </template>
                    </td>
                </tr>
            </template>
        </x-table-server>

        <purchase-import :showDialog.sync="showImportDialog"></purchase-import>
        <tenant-guides-modal :show.sync="showModalGuide"
                             :id="recordId"
                             :type="'purchases'"></tenant-guides-modal>

        <purchase-payments :showDialog.sync="showDialogPurchasePayments"
                           :purchaseId="recordId"
                           :external="true"></purchase-payments>

        <purchase-options :showDialog.sync="showDialogOptions"
                          :recordId="recordId"
                          :showClose="true"></purchase-options>

        <purchase-show-items :showDialog.sync="showDialogPurchaseShowItems"
                             :purchaseId="recordId"></purchase-show-items>
    </div>
</template>

<script>

import {mapActions, mapState} from 'vuex'
import {deletable} from '../../../mixins/deletable'
import PurchaseImport from './import.vue'
import PurchasePayments from '../purchases/purchase_payments/payments.vue'
import PurchaseOptions from './partials/options.vue'
import PurchaseShowItems from "./partials/ShowItems";
import XTableServer from "../../../components/Form/XTableServer";

export default {
    name: 'PurchaseIndex',
    mixins: [deletable],
    components: {XTableServer, PurchaseShowItems, PurchaseImport, PurchasePayments, PurchaseOptions},
    props: [
        'typeUser',
        'configuration',
    ],
    data() {
        return {
            disableGuideBtn: true,
            showModalGuide: false,
            showDialogVoided: false,
            title: 'Listado de compras',
            resource: 'purchases',
            recordId: null,
            showDialogOptions: false,
            showDialogPurchasePayments: false,
            showDialogPurchaseShowItems: false,
            showImportDialog: false,
            columns: {
                date_of_due: {
                    title: 'F. Vencimiento',
                    visible: false
                },
                total_free: {
                    title: 'T.Gratuita',
                    visible: false
                },
                total_unaffected: {
                    title: 'T.Inafecta',
                    visible: false
                },
                total_exonerated: {
                    title: 'T.Exonerado',
                    visible: false
                },
                total_taxed: {
                    title: 'T.Gravado',
                    visible: false
                },
                total_igv: {
                    title: 'T.Igv',
                    visible: false
                },
                total_perception: {
                    title: 'Percepcion',
                    visible: false
                },
                guides: {
                    title: 'Guias',
                    visible: false
                },
                purchase_order: {
                    title: 'Orden de Compra',
                    visible: false
                },

            },
            permissions: {},
        }
    },
    computed: {
        ...mapState([
            'document_types_guide',
            'warehouses',
        ]),
    },
    async created() {
        this.$store.commit('setConfiguration', this.configuration)
        this.$store.commit('setTypeUser', this.typeUser)
        await this.$http.get(`/${this.resource}/tables`)
            .then(response => {
                this.permissions = response.data.permissions
            })
        this.getDocumentTypes()
    },
    methods: {
        getItemDescription(scope) {
            return scope.row.name_product_pdf ? scope.row.name_product_pdf : scope.row.description
        },
        ...mapActions(['loadConfiguration']),
        clickPurchasePayment(recordId) {
            this.recordId = recordId;
            this.showDialogPurchasePayments = true
        },
        clickVoided(recordId = null) {
            this.recordId = recordId
            this.showDialogVoided = true
        },
        clickDownload(download) {
            window.open(download, '_blank');
        },
        clickOptions(recordId = null) {
            this.recordId = recordId
            this.showDialogOptions = true
        },
        clickGuide(recordId = null) {
            this.recordId = recordId
            this.showModalGuide = true
        },
        clickAnulate(id) {
            this.anular(`/${this.resource}/anular/${id}`).then(() =>
                this.$eventHub.$emit('reloadData')
            )
        },
        clickDelete(id) {
            this.delete(`/${this.resource}/delete/${id}`).then(() =>
                this.$eventHub.$emit('reloadData')
            )
        },
        clickImport() {
            this.showImportDialog = true
        },
        getDocumentTypes() {
            this.$http
                .post('/dispatches/getDocumentType')
                .then((result) => {
                    this.$store.commit('setDocumentTypesGuide', result.data)
                }).then(() => {
                this.disableGuideBtn = !this.disableGuideBtn;
            })
        },
        clickShowItems(recordId) {
            this.recordId = recordId;
            this.showDialogPurchaseShowItems = true
        },
        isDateWarning(date_due) {
            let today = Date.now()
            return moment(date_due).isBefore(today)
        },
        clickCreate() {
            location.href = `/${this.resource}/create`;
        }
    }
}
</script>
